import Rating from '@mui/material/Rating';
import clsx from 'clsx';
import { FC, SyntheticEvent } from 'react';
import { IconSVG } from 'atoms/IconSVG';
import { DefaultRatingProps } from './types';
import styles from './Rating.module.css';

interface DynamicRatingProps extends DefaultRatingProps {
  defaultValue?: number;
  onChange?: (
    event: SyntheticEvent<Element, Event>,
    value: number | null,
  ) => void;
  disabled?: boolean;
}

export const DynamicRating: FC<DynamicRatingProps> = ({
  value,
  size = 'small',
  onChange,
  defaultValue,
  className,
  disabled,
}) => {
  return (
    <Rating
      className={className}
      defaultValue={defaultValue}
      value={value}
      disabled={disabled}
      onChange={onChange}
      icon={
        <IconSVG
          type="starFilled"
          className={clsx(styles.dynamicRatingIcon, styles[size])}
        />
      }
      emptyIcon={
        <IconSVG
          type="star"
          className={clsx(styles.dynamicRatingIcon, styles[size])}
        />
      }
    />
  );
};
